var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8291 19.0789H13.5891C13.1791 19.0789 12.8391 18.7389 12.8391 18.3289C12.8391 17.9189 13.1791 17.5789 13.5891 17.5789H17.0791V14.0889C17.0791 13.6789 17.4191 13.3389 17.8291 13.3389C18.2391 13.3389 18.5791 13.6789 18.5791 14.0889V18.3289C18.5791 18.7489 18.2391 19.0789 17.8291 19.0789Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8286 19.0789C17.6386 19.0789 17.4486 19.0089 17.2986 18.8589L11.6386 13.1989C11.3486 12.9089 11.3486 12.4289 11.6386 12.1389C11.9286 11.8489 12.4086 11.8489 12.6986 12.1389L18.3586 17.7989C18.6486 18.0889 18.6486 18.5689 18.3586 18.8589C18.2086 19.0089 18.0186 19.0789 17.8286 19.0789Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17137 0.921631H6.41138C6.82138 0.921631 7.16138 1.26163 7.16138 1.67163C7.16138 2.08163 6.82138 2.42163 6.41138 2.42163H2.92137V5.91162C2.92137 6.32162 2.58137 6.66162 2.17137 6.66162C1.76137 6.66162 1.42137 6.32162 1.42137 5.91162V1.67163C1.42137 1.25163 1.76137 0.921631 2.17137 0.921631Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17184 0.921599C2.36184 0.921599 2.55184 0.9916 2.70184 1.1416L8.36185 6.80159C8.65185 7.09159 8.65185 7.5716 8.36185 7.8616C8.07185 8.1516 7.59185 8.1516 7.30185 7.8616L1.64184 2.2016C1.35184 1.9116 1.35184 1.4316 1.64184 1.1416C1.79184 0.9916 1.98184 0.921599 2.17184 0.921599Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.37176e094f4543895d64126e2cbfab5b.svg";
export { ForwardRef as ReactComponent };